/**
 * Phase 2 — rich content, ratings and per-room photo gallery model.
 * Persisted in `listings` columns: `ratings` (jsonb), `photo_sections` (jsonb),
 * plus plain text columns for the narrative fields.
 */

export interface ListingRatings {
  view?: number;         // vista
  location?: number;     // localização
  privacy?: number;      // privacidade
  exclusivity?: number;  // exclusividade
  liquidity?: number;    // liquidez
}

export const RATING_LABELS: Record<keyof ListingRatings, string> = {
  view: "Vista",
  location: "Localização",
  privacy: "Privacidade",
  exclusivity: "Exclusividade",
  liquidity: "Liquidez",
};

export interface PhotoSection {
  /** Stable slug for React keys + URLs (e.g. "sala-estar", "quarto-1") */
  key: string;
  /** Editable label shown to visitors */
  title: string;
  /** Ordered photo URLs (uploaded via the Storage bucket) */
  images: string[];
}

/** Preset ambient labels — the admin picks from these or types a custom title. */
export const PHOTO_SECTION_PRESETS: string[] = [
  "Fachada", "Sala de estar", "Sala de jantar", "Copa", "Cozinha",
  "Lavabo", "Banheiro social", "Varanda", "Vista",
  "Quarto 1", "Quarto 2", "Quarto 3", "Quarto 4",
  "Suíte 1", "Suíte 2", "Dependência", "Garagem",
  "Área comum", "Piscina", "Sauna", "Salão de festas", "Academia", "Playground",
];

export function slugifyKey(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "") || `sec-${Date.now()}`;
}

export function hasAnyRating(r?: ListingRatings | null): boolean {
  if (!r) return false;
  return Object.values(r).some((v) => typeof v === "number" && v > 0);
}
